import pathOr from 'ramda/src/pathOr';

export default featureName => pathOr( false, ['upi', 'conf', 'features', featureName] )( window );